import http from './http'

export function signIn(data) {
	return http({
		baseURL: window.TRADING_LOGIN_URL || window.location.origin + '/wp-content/plugins/trading-react/login.php',
		data,
		headers:  {'Content-Type': 'multipart/form-data'},
		method: 'POST'
	})
}
